<ion-card
  [ngClass]="['ion-color-' + color]"
  [class.less-spacing]="size === 'small'"
>
  <ion-item
    detail="true"
    [lines]="expanded ? '' : 'none'"
    class="default header-small-18-bold"
    [detailIcon]="toggle ? (expanded ? 'chevron-up' : 'chevron-down') : 'chevron-forward'"
    [ngClass]="size"
    [class.expanded]="expanded"
    (click)="toggle && (expanded = !expanded)"
  >
    <ion-icon
      aria-hidden="true"
      *ngIf="icon"
      [name]="icon"
    ></ion-icon>
    <div class="flex-column-center ion-padding-top ion-padding-bottom">
      <ion-label class="ion-text-wrap">{{ bText }}</ion-label>
      <ion-text
        class="ion-text-wrap ion-margin-start body-text"
        color="grey-400"
        *ngIf="bodyContent"
      >
        {{ bodyContent }}
      </ion-text>
    </div>
    <ion-badge
      class="new-round"
      [attr.aria-label]="bCount + ' new ' + bText"
      color="purple-300"
      *ngIf="bCount"
      slot="end"
    >
      {{ bCount }}</ion-badge
    >
  </ion-item>
  <ng-content
    select=".content"
    *ngIf="expanded"
  ></ng-content>
</ion-card>
